import {
    inject,
    type ObjectGraph,
} from '@jet/environment/dependencies/object-graph';
import type { IntentController } from '@jet/environment/dispatching';
import {
    GetStaticCanonicalUrlIntentKind,
    type GetStaticCanonicalUrlIntent,
} from './get-static-canonical-url-intent';
import { ObjectGraphType } from '~/music-classical-client-js/dependencies';
import { isStaticCanonicalController } from '.';

export const GetStaticCanonicalUrlIntentController: IntentController<GetStaticCanonicalUrlIntent> =
    {
        $intentKind: GetStaticCanonicalUrlIntentKind.Name,

        async perform(
            intent: GetStaticCanonicalUrlIntent,
            objectGraph: ObjectGraph,
        ): Promise<any | string | undefined> {
            const subject = intent.intent;

            const intentDispatcher = inject(
                ObjectGraphType.intentDispatcher,
                objectGraph,
            );

            const controller = intentDispatcher.controller(subject);
            if (!controller) {
                return;
            }

            if (isStaticCanonicalController(controller)) {
                try {
                    return controller.staticCanonicalUrlFor(
                        subject,
                        objectGraph,
                    );
                } catch {
                    return;
                }
            }
        },
    };
